module.exports = __webpack_public_path__ + "static/media/css.c26a73b4.png";